module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/fontawesome-webfont.woff2
// module id = ./node_modules/@ps/common-core/dist/fonts/fontawesome-webfont.woff2
// module chunks = 1